import axiosInstance from '../utils/api-util/utilApi'
import {
  IReqCheckPageExist,
  IReqCreateHelpPage,
  IReqHelpPagePayload,
  IReqPageListPayload,
  IReqRestoreHelpPage,
  IReqUpdateHelpPage,
} from '../../features/feature-help-page/useHelpPage'

const config = { baseURL: process.env.REACT_APP_MASTER_SETUP_SERVICE_URL || '' }

export const getHelpPageList = (payload: IReqHelpPagePayload) => {
  return axiosInstance.post(`/api/helpPage/filter`, JSON.stringify(payload), config)
}

export const getPageList = (payload: IReqPageListPayload) => {
  return axiosInstance.post(`/api/SubmoduleItem/filter`, JSON.stringify(payload), config)
}

export const postHelpPage = (payload: IReqCreateHelpPage) => {
  return axiosInstance.post(`/api/helpPage/create`, JSON.stringify(payload), config)
}

export const postCheckPageExist = (payload: IReqCheckPageExist) => {
  return axiosInstance.post(`/api/helpPage/main-page-exist`, JSON.stringify(payload), config)
}

export const getDetailHelpPage = (id: string) => {
  return axiosInstance.get(`/api/helpPage/${id}`, config)
}

export const getCurrentDetailHelpPage = (id: string) => {
  return axiosInstance.get(`/api/helpPage/by-main-page/${id}`, config)
}

export const putUpdateHelpPage = (id: string, payload: IReqUpdateHelpPage) => {
  return axiosInstance.put(`/api/helpPage/update/${id}`, JSON.stringify(payload), config)
}

export const getHelpPageHistory = (parentId: string, payload: IReqHelpPagePayload) => {
  const reqPayload = {
    ...payload,
    parentId,
  }
  return axiosInstance.post(`/api/helpPageHistory`, JSON.stringify(reqPayload), config)
}

export const putRestoreHelpPage = (payload: IReqRestoreHelpPage) => {
  return axiosInstance.put(`/api/helpPageHistory/restore`, JSON.stringify(payload), config)
}
